package fr.frux.core.common.format

import kotlin.math.abs
import kotlin.math.roundToLong

private const val DECIMALS_SCALE = 10_000L
private const val DECIMALS_WIDTH = 4

/** « 48,7069 N · 2,8711 E » : quatre décimales à virgule, `S` et `O` pour les valeurs négatives. */
fun formatCoordinates(
    latitude: Double,
    longitude: Double,
): String = "${formatAxis(latitude, "N", "S")} · ${formatAxis(longitude, "E", "O")}"

private fun formatAxis(
    value: Double,
    positive: String,
    negative: String,
): String {
    if (!value.isFinite()) return "?"
    // Arrondi sur l'entier mis à l'échelle : la retenue (0,99999 devient 1,0000) reste correcte.
    val scaled = (abs(value) * DECIMALS_SCALE).roundToLong()
    val whole = scaled / DECIMALS_SCALE
    val fraction = (scaled % DECIMALS_SCALE).toString().padStart(DECIMALS_WIDTH, '0')
    return "$whole,$fraction ${if (value < 0) negative else positive}"
}
